import React from "react";
import { Input as UI5Input } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Input({
  className,
  type = "Text",
  value,
  placeholder,
  disabled = false,
  readonly = false,
  required = false,
  valueState = "None",
  valueStateMessage,
  onChange,
  onInput,
  ...props
}) {
  return (
    <UI5Input
      type={type}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      readonly={readonly}
      required={required}
      valueState={valueState}
      valueStateMessage={valueStateMessage}
      onChange={onChange}
      onInput={onInput}
      className={cn(
        "w-full", // Full width by default
        className
      )}
      {...props}
    />
  );
}

/**
 * Input types:
 * - 'Text': Standard text input
 * - 'Email': Email input with validation
 * - 'Number': Number input
 * - 'Password': Password input (masked)
 * - 'Tel': Telephone number input
 * - 'URL': URL input with validation
 *
 * Value states:
 * - 'None': Default state
 * - 'Success': Valid input (green)
 * - 'Warning': Warning state (orange)
 * - 'Error': Invalid input (red)
 * - 'Information': Info state (blue)
 */
